import { PortalPageContent } from "@fero/layouts";
import { useUiConfig } from "adl-service/hooks/use-ui-config";

export const HelpUserManualPage = () => {
  const { userManualUrl } = useUiConfig();
  return (
    <PortalPageContent fixedHeight={true}>
      <iframe
        title="User Manual"
        height="100%"
        width="100%"
        style={{ border: "none", borderRadius: "10px" }}
        src={userManualUrl}
        allowFullScreen
      />
    </PortalPageContent>
  );
};
